import React, { FC } from "react";

import { FlowLayout } from "kw/components/FlowLayout";
import { Referral } from "kw/components/QuestionFlow/Referral";
import { RouteComponentProps } from "@reach/router";
import { useRiskProfile } from "../hooks/useRiskProfile";

type TReferralPage = {
  riskProfileId: string;
};

export const ReferralPage: FC<TReferralPage & RouteComponentProps> = ({
  riskProfileId,
}) => {
  const { riskProfile } = useRiskProfile({ riskProfileId });
  return (
    <FlowLayout
      steps={[
        { label: "Your details", complete: true },
        { label: "Your quote", complete: true },
        { label: "Review and buy", complete: true, active: true },
      ]}
      history={[]}
    >
      <Referral riskProfile={riskProfile} />
    </FlowLayout>
  );
};
